<mat-card class="card">
  <mat-horizontal-stepper
    [linear]="true"
    #stepper
    (selectionChange)="onStepChange()"
  >
    <mat-step [editable]="isEditable" [completed]="isFormSelected()">
      <ng-template matStepLabel>
        <div i18n>Select Form</div>
      </ng-template>
      <section>
        <article>
          <mat-slide-toggle
            [checked]="showOnlyActive"
            (change)="onShowOnlyActiveChange($event)"
          >
            @if (showOnlyActive) {
              <span i18n>Active forms</span>
            }
            @if (!showOnlyActive) {
              <span i18n>All forms</span>
            }
          </mat-slide-toggle>
          <app-form-loader
            [searchable]="true"
            appearance="outline"
            [showOnlyActive]="showOnlyActive"
            (formSelected)="onFormSelected($event)"
          />
        </article>
        <article>
          <mat-card-title>{{ form ? form.title : "--" }}</mat-card-title>
          <app-form-display [form]="form" />
        </article>
        <article>
          <mat-slide-toggle
            [disabled]="form.uuid === null"
            [checked]="form.active"
            (change)="activeChanged()"
          >
            @if (form.active) {
              <span i18n> Form active</span>
            }
            @if (!form.active) {
              <span i18n> Form inactive</span>
            }
          </mat-slide-toggle>
          <br />
          <mat-divider inset="true" />
          <br />
          <button
            matButton="elevated"
            color="accent"
            type="submit"
            matStepperNext
            class="app-panel-button"
            i18n
            [disabled]="form.uuid === null || !form.active"
          >
            Assign Permissions
          </button>
          <button
            matButton="elevated"
            color="primary"
            class="app-panel-button"
            [disabled]="form.uuid === null || !form.active"
            (click)="openInput()"
            i18n
          >
            Change template for pdf
          </button>
          <input
            #fInput
            id="fileInput"
            hidden
            type="file"
            (change)="fileChange($event)"
            name="file"
            accept=".docx"
          />
          @if (base64textString !== "" && form.uuid != null) {
            <button
              matButton="elevated"
              color="warn"
              class="app-panel-button"
              i18n
              (click)="savePdfTemplate(form.uuid)"
            >
              Save new template for pdf
            </button>
          }
        </article>
      </section>
    </mat-step>
    <mat-step [editable]="isEditable">
      <ng-template matStepLabel>
        <div i18n>Assign form</div>
      </ng-template>
      <mat-card-title>
        <span i18n>Form name:</span>
        {{ form?.title }}
      </mat-card-title>
      <section [formGroup]="selectionForm">
        <article>
          <mat-button-toggle-group
            class="app-action-toggle"
            hideSingleSelectionIndicator
            formControlName="actionType"
            (change)="onSelectedAction($event.value)"
          >
            <mat-button-toggle
              value="EDIT"
              i18n-matTooltip
              matTooltip="Edit permissions"
            >
              <mat-icon>edit</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle
              value="SAVE"
              i18n-matTooltip
              matTooltip="Save permissions"
            >
              <mat-icon>save</mat-icon>
            </mat-button-toggle>
          </mat-button-toggle-group>
          <button
            matButton="elevated"
            color="accent"
            class="app-panel-button"
            (click)="loadPermission()"
          >
            <span i18n="@@copyPermBtn"> Copy permissions </span>
          </button>
          <button
            matButton="outlined"
            class="app-panel-button"
            (click)="onGoToPrevious()"
          >
            <mat-icon>arrow_back</mat-icon>
            <span i18n> Go back to form selection </span>
          </button>
        </article>

        <article>
          <div class="app-target-select-row">
            @if (selectedAction != null) {
              <mat-select
                class="app-panel-button app-target-select"
                formControlName="selectedPermissionType"
                (selectionChange)="onSelectedPermissionType($event.value)"
                i18n-placeholder
                placeholder="Assign to.."
              >
                @if (selectedAction === ActionType.EDIT) {
                  @for (
                    target of formTargetTypes | keyvalue;
                    track target;
                    let i = $index
                  ) {
                    @if (
                      target.key !== PermissionType.LANGUAGE ||
                      formMultilanguageEnabled
                    ) {
                      <mat-option [value]="target.key">{{
                        target.value
                      }}</mat-option>
                    }
                  }
                }
                @if (selectedAction === ActionType.SAVE) {
                  <mat-option [value]="PermissionType.STATUS">{{
                    formTargetTypes.status
                  }}</mat-option>
                }
              </mat-select>
            }
          </div>
          <div class="app-form-option-list">
            @switch (permissionType) {
              @case (PermissionType.INSTALLATION) {
                <ng-container>
                  @if (selectedAction != null) {
                    <div class="flex-col-grow center-start">
                      <mat-form-field appearance="outline">
                        <mat-label i18n>Search installation</mat-label>
                        <label>
                          <input matInput formControlName="searchText" />
                        </label>
                      </mat-form-field>
                      <mat-selection-list
                        #installation
                        [compareWith]="compareFn"
                        (selectionChange)="
                          onPermissionObjectSelection(
                            $event,
                            installation.selectedOptions
                          )
                        "
                      >
                        @for (
                          installation of installations$ | async;
                          track installation
                        ) {
                          <mat-list-option
                            [value]="installation"
                            [selected]="
                              checkIfOptionSelected(installation.uuid)
                            "
                          >
                            <div class="flex-row-grow space-between-center">
                              <span style="flex: 1 1 15em"
                                >{{ installation.name | slice: 0 : 24 }}
                              </span>
                              <span style="flex: 1 1 50em">{{
                                installation.customerName | slice: 0 : 35
                              }}</span>
                              <span style="flex: 1 1 10em"
                                >{{ installation.city | slice: 0 : 14 }}
                              </span>
                            </div>
                          </mat-list-option>
                        }
                      </mat-selection-list>
                    </div>
                  }
                </ng-container>
              }
              @case (PermissionType.CUSTOMER) {
                <ng-container>
                  @if (selectedAction != null) {
                    <div class="flex-col-grow center-start">
                      <app-customer-selection
                        (customerSelected)="onCustomerSelected($event)"
                      />
                    </div>
                  }
                </ng-container>
              }
              @default {
                <ng-container>
                  @if (selectedAction != null) {
                    <mat-selection-list
                      class="app-form-selection"
                      #objList
                      [compareWith]="compareFn"
                      (selectionChange)="
                        onPermissionObjectSelection(
                          $event,
                          objList.selectedOptions
                        )
                      "
                    >
                      @for (obj of currentObjectList; track obj) {
                        <mat-list-option
                          class="app-list-row"
                          checkboxPosition="before"
                          [selected]="checkIfOptionSelected(obj.uuid)"
                          [value]="obj"
                        >
                          <div class="flex-row">
                            <span style="flex: 1 0 auto"
                              >{{
                                permissionType === PermissionType.PRODUCT
                                  ? obj.model
                                  : obj.name
                              }}
                            </span>
                            <!-- {{ permissionType === PermissionType.PRODUCT ? obj.model : obj.name}} -->
                          </div>
                        </mat-list-option>
                      }
                    </mat-selection-list>
                  }
                </ng-container>
              }
            }
          </div>
          <div
            [hidden]="
              permissionType !== PermissionType.INSTALLATION ||
              selectedAction === null
            "
          >
            <mat-paginator
              [length]="installationsService.totalNumberOfInst ?? 0"
              [pageSize]="installationsService.pageSize"
              [pageSizeOptions]="[10, 20]"
            />
          </div>
        </article>
        <article>
          <div class="app-perm-panel" [ngClass]="{ excluded: isExcludedMode }">
            <div class="app-perm-panel-header">
              <mat-icon>{{
                isExcludedMode ? "block" : "playlist_add_check"
              }}</mat-icon>
              @if (isExcludedMode) {
                <span i18n> Objects to be excluded</span>
              }
              @if (!isExcludedMode) {
                <span i18n> List of included objects</span>
              }
              <mat-slide-toggle
                class="app-perm-panel-toggle"
                [checked]="isExcludedMode"
                (change)="changeExcluded()"
                i18n-matTooltip
                matTooltip="Switch between included and excluded objects"
              />
            </div>
            <div class="app-sel-obj-container">
              @if (!isExcludedMode) {
                @for (
                  po of selectedPermissionObjectIncluded;
                  track po;
                  let i = $index
                ) {
                  <div
                    class="app-selected-perm-item"
                    [ngClass]="{ excluded: isExcludedMode }"
                  >
                    <span>
                      {{ formTargetTypes[po.permissionType] | slice: 0 : 3 }}
                    </span>
                    |
                    <span> {{ po.name | slice: 0 : 10 }}</span>
                    <mat-icon (click)="removePermissionObjectFromList(i)"
                      >remove_circle</mat-icon
                    >
                  </div>
                  @if (getLogicalOperator(i) === "and") {
                    <div class="break"></div>
                  }
                  <div
                    [ngClass]="{
                      'app-logical-operator':
                        getLogicalOperator(i) === 'and' ||
                        getLogicalOperator(i) === 'or',
                    }"
                  >
                    {{ getLogicalOperator(i) }}
                  </div>
                  @if (getLogicalOperator(i) === "and") {
                    <div class="break"></div>
                  }
                }
              }
              @if (isExcludedMode) {
                @for (
                  po of selectedPermissionObjectExcluded;
                  track po;
                  let i = $index
                ) {
                  <div
                    class="app-selected-perm-item"
                    [ngClass]="{ excluded: isExcludedMode }"
                  >
                    <span>
                      {{ formTargetTypes[po.permissionType] | slice: 0 : 3 }}
                    </span>
                    |
                    <span> {{ po.name | slice: 0 : 10 }}</span>
                    <mat-icon (click)="removePermissionObjectFromList(i)"
                      >remove_circle</mat-icon
                    >
                  </div>
                  @if (getLogicalOperator(i) === "and") {
                    <div class="break"></div>
                  }
                  <div
                    [ngClass]="{
                      'app-logical-operator':
                        getLogicalOperator(i) === 'and' ||
                        getLogicalOperator(i) === 'or',
                    }"
                  >
                    {{ getLogicalOperator(i) }}
                  </div>
                  @if (getLogicalOperator(i) === "and") {
                    <div class="break"></div>
                  }
                }
              }
              @if (
                (isExcludedMode
                  ? selectedPermissionObjectExcluded
                  : selectedPermissionObjectIncluded
                ).length === 0
              ) {
                <span class="app-perm-panel-empty" i18n
                  >No objects selected</span
                >
              }
            </div>
          </div>
          <button
            matButton="outlined"
            class="app-panel-button"
            (click)="clearSelection()"
            [disabled]="!isClearPermissionsButtonDisabled()"
          >
            <mat-icon>clear_all</mat-icon>
            @if (isExcludedMode) {
              <span i18n> Clear excluded </span>
            }
            @if (!isExcludedMode) {
              <span i18n> Clear included </span>
            }
          </button>
          <button
            matButton="elevated"
            color="accent"
            matStepperPrevious
            type="submit"
            class="app-panel-button"
            i18n
            (click)="saveFormAssignment()"
          >
            Save
          </button>
        </article>
      </section>
    </mat-step>
  </mat-horizontal-stepper>
</mat-card>
